import React, { useEffect } from "react";

export function useOutsideAlerter(ref, open, setOpen) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      const logoClass = event?.target?.className;
      if (logoClass && typeof logoClass !== "object") {
        if (logoClass?.indexOf("toggleIcon") !== -1) {
          setOpen(!open);
        } else if (ref?.current && !ref.current?.contains(event?.target)) {
          setOpen(open);
        }
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export const setCookies = (key, value) => {
  // document.cookie = key + "=" + (value || "") + "; path=/";

  document.cookie = `${key}=${value}; path=/; max-age=604800; `;
};

export const getCookies = (key) => {
  const value = ("; " + document.cookie).split(`; ${key}=`).pop().split(";")[0];

  return value;
};

export const deleteCookies = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export let sidebarDrawerInit = true;

export const handleSidebarDrawerInit = () => {
  console.log(200, "handleSidebarDrawerInit", sidebarDrawerInit);
  sidebarDrawerInit = !sidebarDrawerInit;
  return sidebarDrawerInit;
};

export const sideBarList = [
  {
    label: "Dashboard",
    url: "",
    img: <img src={""} />,
  },
  {
    label: "Profile",
    url: "profile",
    img: <img src={""} />,
  },
  {
    label: "Game History",
    url: "game-history",
    img: <img src={""} />,
  },
];

export function getRandomNumbersFromArray(arr, count) {
  const result = new Set();
  while (result.size < count) {
    const randomIndex = Math.floor(Math.random() * arr.length) + 1;
    if (randomIndex == arr.length) {
      result.add(arr[randomIndex - 1]);
    } else {
      result.add(arr[randomIndex]);
    }
  }

  return Array.from(result);
}

export const mapToRange = (value, windowHeight) => {
  const minValue = 1.0;
  const maxValue = 10.0; //  2 

  if (((value - minValue) / (maxValue - minValue)) * windowHeight > 0) {
    return ((value - minValue) / (maxValue - minValue)) * windowHeight;
  } else {
    return 1;
  }

  // const minValue = 0.0; // Changed minValue to 0
  // const maxValue = 10.0; // Or your desired maximum multiplier for mapping

  // const normalizedValue = (value - minValue) / (maxValue - minValue);
  // const mappedValue = normalizedValue * windowHeight;

  // // You might want to set a minimum mapped value to avoid it being exactly 0
  // if (mappedValue < 1) {
  //   return 1;
  // } else {
  //   return mappedValue;
  // }

};

// Utility for lerp
function lerp(start, end, t) {
  return start + (end - start) * t;
}

// Smoothly update mapped value
export const mapToRangeSmooth = (currentValue, previousMappedValue, windowHeight) => {
  const minValue = 0.0;
  const maxValue = 10.0;

  const normalizedValue = (currentValue - minValue) / (maxValue - minValue);
  const targetMappedValue = normalizedValue * windowHeight;

  const smoothedMappedValue = lerp(previousMappedValue, targetMappedValue, 0.1); // t = smoothing factor (0.1 is good)

  return Math.max(smoothedMappedValue, 1); // prevent 0
};

export function createGradientTexture(size) {
  const tempCanvas = document.createElement("canvas");
  tempCanvas.width = size;
  tempCanvas.height = size;
  const ctx = tempCanvas.getContext("2d");

  // Create radial gradient (for shine and shadow)
  const gradient = ctx.createRadialGradient(
    size / 2,
    size / 2,
    size / 6, // Smaller inner radius for sharper shine
    size / 2,
    size / 2,
    size / 2 // Full size for shadow effect
  );

  // Shine (bright center)
  gradient.addColorStop(0, "rgba(255, 255, 255, 0.8)"); // White glow at center
  gradient.addColorStop(0.3, "rgba(255, 255, 255, 0.7)"); // Bright green

  // Mid-tone
  gradient.addColorStop(0.6, "rgba(255, 150, 255, 0.5)"); // Darker green

  // Shadow (dark outer edges)
  gradient.addColorStop(1, "rgba(0, 0, 0, 0.1)"); // Shadow at the edges

  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, size, size);

  return tempCanvas.toDataURL(); // Convert canvas to image
}
